import type { ChatMessage, Match, Offer, OrganiserPrefs, PerformerPrefs } from '../types/marketplace';

export const matches: Match[] = [
  { id: 'm-e3-p1', eventId: 'e3', performerId: 'p1', createdAt: '2026-10-01T10:12:00' },
  { id: 'm-e1-p3', eventId: 'e1', performerId: 'p3', createdAt: '2026-10-05T18:40:00' },
  { id: 'm-e7-p1', eventId: 'e7', performerId: 'p1', createdAt: '2026-09-20T09:00:00' },
  { id: 'm-e1-p5', eventId: 'e1', performerId: 'p5', createdAt: '2026-09-18T14:00:00' },
];

export const offers: Offer[] = [
  { id: 'o1', matchId: 'm-e3-p1', slotId: 'e3-s1', fee: 15000, travel: 2640, setLength: 90, arrival: '15:00', status: 'pending' },
  { id: 'o2', matchId: 'm-e7-p1', slotId: 'e7-s1', fee: 8000, travel: 130, setLength: 45, arrival: '15:15', status: 'accepted' },
  { id: 'o3', matchId: 'm-e1-p5', slotId: 'e1-s3', fee: 30000, travel: 240, setLength: 90, arrival: '18:00', status: 'accepted' },
];

export const messages: Record<string, ChatMessage[]> = {
  'm-e3-p1': [
    { id: 'a1', from: 'system', kind: 'system', text: 'You matched on Mint & Tan’s Vineyard Wedding.', at: '2026-10-01T10:12:00' },
    { id: 'a2', from: 'organiser', kind: 'text', text: 'Hi Ploy! Mint here — we loved your Etta James sample. Could you cover the cocktail hour and our first dance?', at: '2026-10-01T10:20:00' },
    { id: 'a3', from: 'performer', kind: 'text', text: 'Congratulations ka! Absolutely. I’d suggest this one for the first dance:', at: '2026-10-01T11:02:00' },
    { id: 'a4', from: 'performer', kind: 'song', songId: 'k2', at: '2026-10-01T11:02:30' },
    { id: 'a5', from: 'organiser', kind: 'text', text: 'Perfect. Could you add one Thai song for our parents too? Sending an offer now — room at the resort included.', at: '2026-10-05T16:45:00' },
    { id: 'a6', from: 'organiser', kind: 'offer', offerId: 'o1', at: '2026-10-05T16:46:00' },
  ],
  'm-e1-p3': [
    { id: 'b1', from: 'system', kind: 'system', text: 'You matched on Rooftop Soul Sessions.', at: '2026-10-05T18:40:00' },
    { id: 'b2', from: 'performer', kind: 'text', text: 'Thanks for the match! We could do two 45-minute sets with a short break. Is there a piano on the roof or should we bring a stage piano?', at: '2026-10-05T19:05:00' },
  ],
  'm-e7-p1': [
    { id: 'c1', from: 'system', kind: 'system', text: 'You matched on Talat Noi Street Party.', at: '2026-09-20T09:00:00' },
    { id: 'c2', from: 'organiser', kind: 'text', text: 'Could you open the party with a 45-minute soul set?', at: '2026-09-20T09:30:00' },
    { id: 'c3', from: 'performer', kind: 'text', text: 'Love it — count me in!', at: '2026-09-20T10:10:00' },
    { id: 'c4', from: 'organiser', kind: 'offer', offerId: 'o2', at: '2026-09-20T10:30:00' },
    { id: 'c5', from: 'system', kind: 'confirmed', offerId: 'o2', at: '2026-09-20T11:00:00' },
  ],
  'm-e1-p5': [
    { id: 'd1', from: 'system', kind: 'system', text: 'You matched on Rooftop Soul Sessions.', at: '2026-09-18T14:00:00' },
    { id: 'd2', from: 'organiser', kind: 'offer', offerId: 'o3', at: '2026-09-18T15:00:00' },
    { id: 'd3', from: 'system', kind: 'confirmed', offerId: 'o3', at: '2026-09-18T16:20:00' },
    { id: 'd4', from: 'performer', kind: 'text', text: 'Can’t wait. We’ll load in through the service lift at 6.', at: '2026-09-18T16:30:00' },
  ],
};

export const performerPrefs: PerformerPrefs = {
  genres: ['Soul', 'R&B', 'Jazz', 'T-Pop'],
  eventTypes: ['Bar gig', 'Wedding', 'Corporate', 'Private party'],
  minFee: 7000,
  maxTravelKm: 200,
  days: ['Thu', 'Fri', 'Sat', 'Sun'],
  multiActOk: true,
};

export const organiserPrefs: OrganiserPrefs = {
  genres: ['Soul', 'R&B', 'Jazz', 'Funk'],
  actTypes: ['Solo singer', 'Duo', 'Band'],
  budgetMax: 40000,
  maxDistanceKm: 40,
  minRating: 4.5,
  mustHaveKeys: ['Valerie'],
};

export const cannedReplies: Record<'performer' | 'organiser', string[]> = {
  organiser: [
    'Sounds great — that works for us.',
    'Perfect. Is there anything you need from us on the night?',
    'Lovely, I’ll check with the venue and come back to you today.',
  ],
  performer: [
    'Thanks! That works for me.',
    'Happy to — I can bring my own PA if needed.',
    'Sounds great. I’ll put a Thai and English setlist together for you.',
  ],
};
